import { render, staticRenderFns } from "./ParcelSellerSection.vue?vue&type=template&id=6a30a8c4&scoped=true&"
import script from "./ParcelSellerSection.vue?vue&type=script&lang=js&"
export * from "./ParcelSellerSection.vue?vue&type=script&lang=js&"
import style0 from "./ParcelSellerSection.vue?vue&type=style&index=0&id=6a30a8c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a30a8c4",
  null
  
)

export default component.exports